import React, { Component } from 'react'
import { Menu as MenuAntd, Icon, Tooltip } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import { roles } from '../../util/Roles';
import { esBarras } from '../../util/generics';

const { SubMenu } = MenuAntd;
const userId = localStorage.getItem("id_user");

/**
 * Clase para ver el componente del menú
 */
class Menu extends Component {
    state = {
        catalogo_seleccionado: undefined
    }

    /**
     * Función que se ejecuta cuando se da clic en el menú
     * @param: e. valor del menú seleccionado
     * @return: nada.
     */
    handleClick = (e) => {
        let state = { ...this.state };
        state.catalogo_seleccionado = e.key;
        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando se cierra sesión
     */
    logout = () => {
        window.location.replace("/inicio")
        localStorage.clear()
    }

    render() {
        let state = { ...this.state }
        let url = this.props.location.pathname;

        if (url.includes('/capturar_inventario_pt/true/'))
            url = '/capturar_inventario_pt/true/';

        if (url.includes('/nuevoInventario/'))
            url = '/nuevoInventario/';

        switch (url) {
            case '/':
                state.catalogo_seleccionado = "1"
                break;
            case '/inicio':
                state.catalogo_seleccionado = "1"
                break;
            case '/articulos_auxiliares':
                state.catalogo_seleccionado = "2"
                break;
            case '/usuarios':
                state.catalogo_seleccionado = "3"
                break;
            case '/capturar_inventario':
                state.catalogo_seleccionado = "4"
                break
            case '/historico_inventario':
                state.catalogo_seleccionado = "5"
                break;
            case '/facturacion':
                state.catalogo_seleccionado = "7"
                break;
            case '/capturar_inventario_pt/true/':
                state.catalogo_seleccionado = "8"
                break;
            case '/nuevoInventario/':
                state.catalogo_seleccionado = "8"
                break;
            case '/articulos_pti/0':
                state.catalogo_seleccionado = "9"
                break;
            case '/articulos_pte/1':
                state.catalogo_seleccionado = "10"
                break;
            case '/historico_inventario_pt/true':
                state.catalogo_seleccionado = "11"
                break;
            case '/capturar_inventario_pt/false':
                state.catalogo_seleccionado = "12"
                break;
            case '/historico_inventario':
                state.catalogo_seleccionado = "13"
                break;
            case '/diferencia_inventario':
                state.catalogo_seleccionado = "14"
                break;
            case '/mermas':
                state.catalogo_seleccionado = "15"
                break;
            case '/articulos_ciclicos':
                state.catalogo_seleccionado = "16"
                break;
            case '/capturar_inventario_ciclico':
                state.catalogo_seleccionado = "17"
                break;
            default:
                state.catalogo_seleccionado = "1"
                break;
        }
        return (
            <MenuAntd mode="inline" theme='light' selectedKeys={[state.catalogo_seleccionado]} defaultOpenKeys={['sub1', 'sub2', 'sub3', 'sub4', 'sub6']} onClick={this.props.onMenuClick}>
                <MenuAntd.Item key="1" id="menu-inicio">
                    <Icon type="home" /><span>Inicio</span>
                    <NavLink to="/inicio"></NavLink>
                </MenuAntd.Item>
                {ShowMenuItem([roles.Admin]) &&
                    <SubMenu key="sub1" title={
                        <span>
                            <Icon type="setting" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Configuración</span>
                        </span>
                    }>
                        {ShowMenuItem([roles.Admin]) &&
                            <MenuAntd.Item key="3" id="menu-usuarios">
                                <Icon type="user" /><span>Usuarios</span>
                                <NavLink to="/usuarios"></NavLink>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
                {ShowMenuItem([roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]) &&
                    <SubMenu key="sub2" title={
                        <span>
                            <Icon type="folder" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Administración</span>
                        </span>
                    }>
                        {false &&//ShowMenuItem([roles.Admin, roles.Operador]) &&
                            <MenuAntd.Item key="2" id="menu-auxiliares">
                                <Icon type="bars" /><span>Artículos Auxiliares</span>
                                <NavLink to="/articulos_auxiliares"></NavLink>
                            </MenuAntd.Item>
                        }
                        {false &&//ShowMenuItem([roles.Admin, roles.Operador]) &&
                            <MenuAntd.Item key="9" id="menu-pti">
                                <Icon type="bars" /><span>Artículos Interno</span>
                                <NavLink to="/articulos_pti/0"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]) &&
                            <MenuAntd.Item key="10" id="menu-pte">
                                <Icon type="bars" /><span>Artículos</span>
                                <NavLink to="/articulos_pte/1"></NavLink>
                            </MenuAntd.Item>
                        }

                        {ShowMenuItem([roles.AdminCatalogos]) && ShowMenuItem([roles.UsuarioBarra]) && esBarras() &&
                            <MenuAntd.Item key="16" id="menu-cic">
                                <Icon type="sync" /><span>Artículos cíclicos</span>
                                <NavLink to="/articulos_ciclicos"></NavLink>
                            </MenuAntd.Item>
                        }

                    </SubMenu>
                }
                {false &&//ShowMenuItem([roles.Operador, roles.Admin]) &&
                    <SubMenu key="sub3" title={
                        <Tooltip placement="top" title="Inventario Auxiliares">
                            <span>
                                <Icon type="appstore" />
                                <span style={{ fontSize: "18px", fontWeight: 700 }}>Inventario Auxiliares</span>
                            </span>
                        </Tooltip>
                    }>
                        {ShowMenuItem([roles.Operador]) &&
                            <MenuAntd.Item key="4" id="menu-capturar">
                                <Icon type="edit" /><span>Capturar</span>
                                <NavLink to="/capturar_inventario"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Operador, roles.Admin]) &&
                            <MenuAntd.Item key="5" id="menu-historico">
                                <Icon type="line-chart" /><span>Histórico</span>
                                <NavLink to="/historico_inventario"></NavLink>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
                {ShowMenuItem([roles.Operador, roles.Admin, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]) && !(ShowMenuItem([roles.Admin]) && esBarras()) &&
                    <SubMenu key="sub4" title={
                        <Tooltip placement="top" title="Inventario">
                            <span>
                                <Icon type="appstore" />
                                <span style={{ fontSize: "18px", fontWeight: 700 }}>Inventario</span>
                            </span>
                        </Tooltip>
                    }>
                        {ShowMenuItem([roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]) &&
                            <MenuAntd.Item key="8" id="menu-capturar_pte">
                                <Icon type="edit" /><span>Capturar</span>
                                <NavLink to="/capturar_inventario_pt/true/-1"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]) && ShowMenuItem([roles.UsuarioBarra]) && esBarras() &&
                            <MenuAntd.Item key="17" id="menu-capturar_cic">
                                <Icon type="redo" /><span>Capturar cíclico</span>
                                <NavLink to="/capturar_inventario_ciclico"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Admin]) && !esBarras() &&
                            <MenuAntd.Item key="11" id="menu-historico_pte">
                                <Icon type="bars" /><span>Pendiente SAP</span>
                                <NavLink to="/historico_inventario_pt/true"></NavLink>
                            </MenuAntd.Item>
                        }
                        {(ShowMenuItem([roles.Admin]) || userId == 16) && !esBarras() &&
                            <MenuAntd.Item key="13" id="menu-historico_pte">
                                <Icon type="bars" /><span>Histórico</span>
                                <NavLink to="/historico_inventario"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Operador, roles.Admin]) && !esBarras() &&
                            <MenuAntd.Item key="7" id="menu-diferencia-inv">
                                <Icon type="line-chart" /><span>Facturación</span>
                                <NavLink to="/facturacion"></NavLink>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
                {false &&//ShowMenuItem([roles.Operador, roles.Admin]) &&
                    <SubMenu key="sub5" title={
                        <span>
                            <Icon type="appstore" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Inventario Interno</span>
                        </span>
                    }>
                        {ShowMenuItem([roles.Operador]) &&
                            <MenuAntd.Item key="12" id="menu-capturar_pti">
                                <Icon type="edit" /><span>Capturar</span>
                                <NavLink to="/capturar_inventario_pt/false"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Operador, roles.Admin]) &&
                            <MenuAntd.Item key="13" id="menu-historico_pti">
                                <Icon type="line-chart" /><span>Histórico</span>
                                <NavLink to="/historico_inventario_pt/false"></NavLink>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
                {ShowMenuItem([roles.Operador, roles.Admin, roles.Asesor, roles.Auditor, roles.AdminCatalogos]) &&
                    <SubMenu key="sub6" title={
                        <span>
                            <Icon type="appstore" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Reportes</span>
                        </span>
                    }>
                        {ShowMenuItem([roles.Operador, roles.Admin, roles.Asesor, roles.Auditor, roles.AdminCatalogos]) &&
                            <MenuAntd.Item key="14" id="menu-diferencia-inv">
                                <Icon type="edit" /><span>Diferencia inventario</span>
                                <NavLink to="/diferencia_inventario"></NavLink>
                            </MenuAntd.Item>
                        }
                        {ShowMenuItem([roles.Operador, roles.Admin, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]) &&
                            <MenuAntd.Item key="15" id="menu-mermas">
                                <Icon type="line-chart" /><span>Mermas</span>
                                <NavLink to="/mermas"></NavLink>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
            </MenuAntd>
        )
    }
}

export default withRouter(Menu);